/*
 * @Descripttion:
 * @version:
 * @Author: sueRimn
 * @Date: 2023-10-12 14:04:03
 * @LastEditors: sueRimn
 * @LastEditTime: 2024-03-05 14:48:21
 */
import request from '@/utils/request'
import type { CommonRes, IDealFlowsNotPublicResponse } from '@/typings'

// Deal Log
export async function getDealLog(params: any) {
  return request('/api/v2/project/search/deal_logs', {
    method: 'POST',
    data: params
  })
}

// Deal Flows
export async function getDealFlows(params: any) {
  return request('/api/v2/project/search/deal_flows', {
    method: 'POST',
    data: params
  })
}

interface IGetDealFlowsNotPublicParams {
  channel_ids?: number[]
  circle_code?: string
  display_pm?: number
  is_special_not_public?: number
  memo_ctime_end?: string
  memo_ctime_start?: string
  need_follow_on?: number
  page?: number
  process_status?: string
  processor?: number
  product_thesis_ids?: number[]
  project_name?: string
  size?: number
  sort?: string
  update_time_end?: string
  update_time_start?: string
  vote_system?: number
}
// Deal Flows
export async function getDealFlowsNotPublic(params: IGetDealFlowsNotPublicParams) {
  return request<CommonRes<IDealFlowsNotPublicResponse>>(
    '/api/v2/project/search/deal_flows_special_not_public',
    {
      method: 'POST',
      data: params
    }
  )
}

// deal log/pool表格数据
export async function getDealLogData(params: any) {
  return request('/api/v2/project/search/deal_pool', {
    method: 'POST',
    data: params
  })
}
export async function getDealFlowsFollowOnNoParticipate(params: any) {
  return request('/api/v2/project/search/deal_flows_follow_on_no_participate', {
    method: 'POST',
    data: params
  })
}
/** 获取退出Memo */
export interface IDealFlowsExitMemoParams {
  channel_ids?: number[]
  circle_code?: string
  display_pm?: number
  memo_ctime_end?: string
  memo_ctime_start?: string
  need_follow_on?: number
  page?: number
  process_status?: string
  processor?: number
  project_name?: string
  size?: number
  sort?: string
  update_time_end?: string
  update_time_start?: string
  vote_system?: number
}

export async function getDealFlowsExitMemo(params: IDealFlowsExitMemoParams) {
  return request('/api/v2/project/search/deal_flows_exit', {
    method: 'POST',
    data: params
  })
}
